import Logo from '../assets/projects/Logo.jpg'
// import RealEst from '../assets/projects/realestate.jpg'

export const data=[
    {
        id:1,
        name:"HLA Registration Form",
        image:Logo, 
        fileName:"association-membership-form.pdf",
    },
    {
        id:2,
        name:"HLA Constitution",
        image:Logo, 
        fileName:"",
    },
    {
        id:3,
        name:"List of HLA Members",
        image:Logo, 
        fileName:"",
    },
    // {
    //     id:4,
    //     name:"Vision & Mission",
    //     image:Logo, 
    //     fileName:"",
    // },


]